module.exports = __webpack_public_path__ + "static/media/covid-icon.4a58633c.svg";